import { LocaleKeys } from '../../../../locale/translation-types'

export enum SchoolLevelTaughtEnum {
  OTHER = 'OTHER',
  BTS_IUT_UNIVERSITY = 'BTS_IUT_UNIVERSITY',
  PREPARATORY_CLASSES = 'PREPARATORY_CLASSES',
  COLLEGE = 'COLLEGE',
  HIGH_SCHOOL = 'HIGH_SCHOOL',
  PRIMARY = 'PRIMARY'
}

export const schoolLevelTaughtEnumMapping: Record<SchoolLevelTaughtEnum, LocaleKeys> = {
  [SchoolLevelTaughtEnum.PRIMARY]: 'school.level.taught.enum.PRIMARY',
  [SchoolLevelTaughtEnum.COLLEGE]: 'school.level.taught.enum.COLLEGE',
  [SchoolLevelTaughtEnum.HIGH_SCHOOL]: 'school.level.taught.enum.HIGH_SCHOOL',
  [SchoolLevelTaughtEnum.BTS_IUT_UNIVERSITY]: 'school.level.taught.enum.BTS_IUT_UNIVERSITY',
  [SchoolLevelTaughtEnum.PREPARATORY_CLASSES]: 'school.level.taught.enum.PREPARATORY_CLASSES',
  [SchoolLevelTaughtEnum.OTHER]: 'school.level.taught.enum.OTHER'
}
